import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('🔧 Supabase Config Debug:');
console.log('URL exists:', !!supabaseUrl);
console.log('Key exists:', !!supabaseAnonKey);

// Validate and create the client
let supabase;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase environment variables are missing!');
  
  // Create a mock client that throws meaningful errors
  supabase = {
    from: () => {
      throw new Error('Supabase not configured. Check your .env file.');
    }
  };
} else {
  console.log('✅ Supabase credentials validated');
  
  // Validate URL format
  if (!supabaseUrl.startsWith('https://')) {
    console.error('❌ Invalid Supabase URL format');
  }
  
  // Validate key format
  if (!supabaseAnonKey.startsWith('eyJ')) {
    console.error('❌ Invalid Supabase key format');
  }
  
  // Create the real client
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
    }
  });
}

// Export at the top level (not inside if/else blocks)
export { supabase };